import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ChevronsRight24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path fillRule='evenodd' clipRule='evenodd' d='M6.707 6.293a1 1 0 0 0-1.414 1.414L9.586 12l-4.293 4.293a1 1 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Zm7 0a1 1 0 1 0-1.414 1.414L16.586 12l-4.293 4.293a1 1 0 0 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414l-5-5Z' /></svg>);
